import { useTranslation } from '@kostbar/i18n'
import { useAuth } from '@/features/auth/hooks/use-auth'

export function UserInfo() {
  const { t: tProfile } = useTranslation('profile')
  const { user } = useAuth()

  if (!user) {
    return null
  }

  return (
    <div className="space-y-4">
      <div>
        <label className="text-sm font-medium text-muted-foreground">
          {tProfile('email')}
        </label>
        <p className="text-lg">{user.email}</p>
      </div>

      {user.tenantId && (
        <div>
          <label className="text-sm font-medium text-muted-foreground">
            {tProfile('tenantId')}
          </label>
          <p className="text-lg">{user.tenantId}</p>
        </div>
      )}

      {user.restaurantIds && user.restaurantIds.length > 0 && (
        <div>
          <label className="text-sm font-medium text-muted-foreground">
            {tProfile('restaurantIds')}
          </label>
          <p className="text-lg">{user.restaurantIds.join(', ')}</p>
        </div>
      )}
    </div>
  )
}
